<template>
  <div class="home">
    <v-app-bar absolute id="app-bar" color="#ED6D00" style="height: 64px" elevate-on-scroll scroll-target="#scrolling-techniques-7">
      <v-btn icon class="d-md-none" @click="drawer = !drawer" style="color: white; margin-right: 6px; margin-left: -5px">
        <v-icon size="28">{{ drawer ? 'mdi-close' : 'mdi-menu' }}</v-icon>
      </v-btn>

      <div class="d-inline-block" style="width:165px" @click="redirectPath('/jobAssignmentList')">
        <v-img v-if="language != 'en'" :src="images.new_logo_tw" width=100 alt="KLNLOGO"></v-img>
        <v-img v-if="language == 'en'" :src="images.new_logo_en" width=100 alt="KLNLOGO"></v-img>
      </div>
      <Breadcrumb style="margin-left: 20px;" class="d-none d-md-flex" />
      <v-spacer></v-spacer>
      <!-- Notification Center -->
      <v-menu offset-y :close-on-content-click="false" v-model="showNotificationCenter" nudge-bottom="4" max-width="320">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="notificationCounts.jobAssignment" icon v-bind="attrs" v-on="on" class="mx-n1 header-icon-btn">
            <v-badge color="#FFFFFF" dot bottom :value="hasNotifications">
              <v-icon style="color:#FFF">mdi-calendar-badge</v-icon>
            </v-badge>
          </v-btn>
          <v-btn v-else icon v-bind="attrs" v-on="on" class="mx-n1 header-icon-btn">
            <v-badge color="#FFFFFF" dot bottom :value="hasNotifications">
              <v-icon style="color:#FFF">mdi-calendar-blank</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-card class="notification-center-card" style="border-radius: 10px; width: 300px; box-shadow: 0 4px 20px rgba(0,0,0,0.15);">
          <div class="text-center pt-5" style="font-size: 20px; font-weight: 700; color: #222;">
            {{$t('__notificationCenter') || 'Notification Center'}}
          </div>
          <div class="px-3 pt-3 pb-5">
            <v-row class="ma-0 text-center">
              <v-col
                v-if="canView('JobAssignment')"
                :cols="notificationColSize"
                class="px-0 pt-1 pb-3 notification-col"
                @click="redirectPath('/jobAssignmentList'); showNotificationCenter = false"
              >
                <div class="px-1" style="font-size: 32px; font-weight: 700; color: #ED6D00; line-height: 1.2;">{{ notificationCounts.jobAssignment }}</div>
                <div class="px-1" style="font-size: 12px; color: #888; line-height: 1.2; margin-top: 6px;">{{ $t('__notifJobAssignment') }}</div>
              </v-col>
              <v-col
                v-if="canView('WarrantyAndMaintenance')"
                :cols="notificationColSize"
                class="px-0 pt-1 pb-3 notification-col"
                @click="redirectPath('/warrantyAndMaintenance?tab=0'); showNotificationCenter = false"
              >
                <div class="px-1" style="font-size: 32px; font-weight: 700; color: #ED6D00; line-height: 1.2;">{{ notificationCounts.maintenanceExpiry }}</div>
                <div class="px-1" style="font-size: 12px; color: #888; line-height: 1.2; margin-top: 6px;">{{ $t('__notifMaintenanceExpiry') }}</div>
              </v-col>
              <v-col
                v-if="canView('WarrantyAndMaintenance')"
                :cols="notificationColSize"
                class="px-0 pt-1 pb-3 notification-col"
                @click="redirectPath('/warrantyAndMaintenance?tab=1'); showNotificationCenter = false"
              >
                <div class="px-1" style="font-size: 32px; font-weight: 700; color: #ED6D00; line-height: 1.2;">{{ notificationCounts.deviceExpiry }}</div>
                <div class="px-1" style="font-size: 12px; color: #888; line-height: 1.2; margin-top: 6px;">{{ $t('__notifDeviceExpiry') }}</div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-menu>
      
      <!-- 語言切換選單 -->
      <v-menu offset-y nudge-bottom="4">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" class="mx-n2 header-icon-btn d-none d-md-inline-flex">
            <v-icon style="color:#FFF">mdi-web</v-icon>
          </v-btn>
        </template>
        <v-list dense style="min-width: 120px; padding: 0;">
          <v-list-item style="cursor: pointer" @click="language = 'tw'">
            <v-list-item-title class="text-center" style="color: #ED6D00; font-weight: 500;">{{$t('__languageTw')}}</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item style="cursor: pointer" @click="language = 'en'">
            <v-list-item-title class="text-center" style="color: #ED6D00; font-weight: 500;">{{$t('__languageEn')}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- 個人姓名選單 -->
      <v-menu offset-y nudge-bottom="4">
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" class="d-flex align-center py-2" style="cursor: pointer; margin-left: 12px; height: 100%;">
            <span class="headerName search-bar-max" style="color:#FFF; font-weight: 500;">Hi, {{$root.LOGININFO.name}}</span>
            <v-icon style="color:#FFF" size="24" class="ml-1">mdi-menu-down</v-icon>
          </div>
        </template>
        <v-list dense style="min-width: 140px; padding: 0;">
          <v-divider class="d-md-none"></v-divider>
          <v-list-item class="d-md-none" style="cursor: pointer" @click="language = 'tw'">
            <v-list-item-title class="text-center" style="color: #ED6D00; font-weight: 500;">{{$t('__languageTw')}}</v-list-item-title>
          </v-list-item>
          <v-divider class="d-md-none"></v-divider>
          <v-list-item class="d-md-none" style="cursor: pointer" @click="language = 'en'">
            <v-list-item-title class="text-center" style="color: #ED6D00; font-weight: 500;">{{$t('__languageEn')}}</v-list-item-title>
          </v-list-item>
          <v-divider class="d-md-none"></v-divider>
          <v-list-item style="cursor: pointer" @click="redirectPath('/editProfile')">
            <v-list-item-title class="text-center" style="color: #ED6D00; font-weight: 500;">{{$t('__editProfile')}}</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item style="cursor: pointer" @click="logout">
            <v-list-item-title class="text-center" style="color: #ED6D00; font-weight: 500;">{{$t('__logout')}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- 手機板型選單抽屜 -->
    <v-navigation-drawer v-model="drawer" absolute temporary class="d-md-none" style="z-index: 100; top: 64px; height: calc(100% - 64px); background-color: #FAFAFA; width: 100%;">
      <v-list nav dense class="pa-0 mt-3" style="background-color: transparent !important">
        <template v-for="(menu, i) in menus">
          <v-list-item v-if="enableMenu(menu)" :key="i" @click="selectMenu(menu)" :class="'px-6 py-2'" class="menu-item-row" style="min-height: 52px !important; margin: 8px 80px 8px 16px !important;">
            <v-list-item-icon class="mr-4 align-self-center my-0">
              <v-icon size="24" :color="menu.name == currentMenuName ? '#ED6D00' : '#444'">{{menu.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="pa-0">
              <v-list-item-title class="font-weight-bold text-left multiline-title" :style="{ color: menu.name == currentMenuName ? '#ED6D00' : '#444', fontSize: '1.05rem', lineHeight: '1.5' }">
                {{menu.name}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-row id="app-content" class="fill-height mx-0" :style="viewStyle">
      <!-- Sidebar -->
      <div 
        :class="isCollapsed ? 'sidebar-collapsed' : 'sidebar-expanded'" 
        class="app-content-left fill-height pa-0 d-none d-md-flex flex-column white" 
        style="box-shadow: 2px 0px 5px #bbbbbb; transition: width 0.3s ease; overflow-x: hidden; z-index: 5; flex: 0 0 auto;"
      >
        <div class="flex-grow-1 overflow-y-auto">
          <v-list nav class="pa-0 mt-3">
            <template v-for="(menu, i) in menus">
              <v-list-item 
                v-if="enableMenu(menu)"
                :key="i"
                @click="selectMenu(menu)"
                :style="{ backgroundColor: 'transparent' }"
                :class="isCollapsed ? 'px-0' : 'px-4'"
                class="menu-item-row"
              >
                <v-list-item-icon :class="isCollapsed ? 'mx-auto' : 'mr-4'" class="my-2">
                  <v-icon :color="menu.name == currentMenuName ? '#ED6D00' : '#444'">
                    {{menu.icon}}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content v-if="!isCollapsed" class="pa-0 py-1">
                  <v-list-item-title 
                    class="font-weight-bold text-left multiline-title"
                    :style="{ color: menu.name == currentMenuName ? '#ED6D00' : '#444' }"
                  >
                    {{menu.name}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </div>

        <!-- Collapse Toggle -->
        <div class="pa-0">
          <v-divider></v-divider>
          <v-list nav class="pa-0">
            <v-list-item 
              @click="isCollapsed = !isCollapsed" 
              :class="isCollapsed ? 'px-0' : 'px-4'"
              class="menu-item-row"
            >
              <v-list-item-icon :class="isCollapsed ? 'mx-auto' : 'mr-4'" class="my-2">
                <v-icon color="#444">{{ isCollapsed ? 'mdi-arrow-collapse-right' : 'mdi-arrow-collapse-left' }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content v-if="!isCollapsed" class="pa-0">
                <v-list-item-title class="font-weight-bold text-left" style="color: #444">{{$t('__collapse') || 'Collapse'}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </div>
      
      <!-- Main Content -->
      <v-col class="pa-0 fill-height" style="overflow-y: auto; z-index: 0; background: #f4f7f9">
        <router-view />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import i18n from '@/plugins/i18n'
import { getEmployeeInfo, getRoles } from '@/utils/auth'
import { updateLanguageSetting } from '@/api/account'

export default {
  name: 'Home',
  components: {Breadcrumb},
  data: () => ({
    images:{
      new_logo_tw: require('@/assets/image/KLN_logo_W.png'),
      new_logo_en: require('@/assets/image/KLN_logo_W.png'),
    },
    menus:[],
    viewStyle:{},
    currentMenuName:'',
    currentMenuIndex:-1,
    currentSubName:'',
    language:'',
    NOTICE_COUNT:0,
    expansionPanelValue:-1,
    msgList:[],
    height1:400,
    permission:[],
    showBell: false,
    newEvent:0,
    userPermissions: [],
    isCollapsed: false,
    drawer: false, // 手機抽屜選單狀態
    showNotificationCenter: false,
    notificationCounts: {
      jobAssignment: 0,
      maintenanceExpiry: 0,
      deviceExpiry: 0
    },
    notificationTimer: null,
  }),
  computed: {
    /**
     * 根據可見項目數動態計算每欄寬度
     * JobAssignment: 1 項; WarrantyAndMaintenance: 2 項 (maintenance + device)
     */
    notificationColSize() {
      let count = 0
      if (this.canView('JobAssignment')) count++
      if (this.canView('WarrantyAndMaintenance')) count += 2
      if (count <= 1) return 12
      if (count === 2) return 6
      return 4 // count === 3
    },
    hasNotifications() {
      let sum = 0
      if (this.canView('JobAssignment')) sum += this.notificationCounts.jobAssignment
      if (this.canView('WarrantyAndMaintenance')) {
        sum += this.notificationCounts.maintenanceExpiry
        sum += this.notificationCounts.deviceExpiry
      }
      return sum > 0
    }
  },
  mounted(){
    if(!sessionStorage.getItem('manageMemberToken')){
      this.redirectPath('/login')
    }
    this.language = i18n.locale
    this.initLanguage()

    let self = this
    window.onresize = function windowResize () {
      // console.log('window.innerHeight: ' + window.innerHeight)
      self.$root.$emit('windowInnerHeight', window.innerHeight)
    }

    // 定時刷新通知中心 (每 60 秒)
    this.notificationTimer = setInterval(() => {
      this.fetchNotificationCounts()
    }, 60000)
  },
  beforeDestroy() {
    // 清除定時器，避免內存洩漏
    if (this.notificationTimer) {
      clearInterval(this.notificationTimer)
      this.notificationTimer = null
    }
  },
  created(){
    this.calculateWindows()
    // this.getMsgList()
    this.$root.LOGININFO = {name:sessionStorage.getItem('manageMemberName')}

    if(!sessionStorage.getItem('manageMemberSysId')){
      this.redirectPath('/login')
    }

    this.loadUserPermissions()
    this.getData()
    this.fetchNotificationCounts()

    this.$root.$on('menuName',(value)=>{
      this.currentMenuName = value
      this.currentMenuIndex = this.menus.findIndex(function(item){return item.name == value})
    })
    this.$root.$on('subMenuName',(value)=>{
      this.currentSubName = value
    })
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
    // 當前登入者的角色/權限被更新時，重新載入選單權限和通知計數
    this.$root.$on('userPermissionsUpdated', () => {
      console.log('🔄 [Home] 權限已更新，重新載入選單和通知...')
      this.loadUserPermissions()
      this.fetchNotificationCounts()
    })
  },
  beforeMount(){
    if(sessionStorage.getItem('SYS-PERMISSION')){
      let permission = JSON.parse(sessionStorage.getItem('SYS-PERMISSION'))
      this.$system.system = permission.system
      this.$system.operation = permission.operation

      this.$system.dean = permission.dean

      this.$system.employeelist = permission.employeelist
      this.$system.authlist = permission.authlist
      this.$system.orderlist = permission.orderlist
      this.$system.healthydoclist = permission.healthydoclist
      this.$system.neolist = permission.neolist

      this.$system.clinicroom = permission.clinicroom
      this.$system.devicetransfer = permission.devicetransfer

      this.$system.coupondelivery = permission.coupondelivery
      this.$system.faqlist = permission.faqlist

      this.$system.mailbox = permission.mailbox
    }
  },
  watch:{
    "language": {
      handler: function() {
        this.setLanguage(this.language)
        this.initLanguage()
        this.$root.$emit('language', this.language)
        
        const langMap = {
          'tw': 'zh-TW',
          'en': 'en-US',
          'cn': 'zh-CN'
        }
        const langSetting = langMap[this.language] || this.language
        
        // 保存到 localStorage 供 API 請求使用
        localStorage.setItem('languageSetting', langSetting)
        // 保存到 localStorage 供 i18n 插件初始化使用
        localStorage.setItem('locale', this.language)
        
        const account = sessionStorage.getItem('loginAccount')
        if (account && langSetting) {
          updateLanguageSetting(account, langSetting).catch(err => {
            console.log('Update language setting failed:', err)
          })
        }
      },
      immediate: true
    },
    "$route": {
      handler: function(val) {
        this.updateMenuHighlight(val.path)
      },
      immediate: true
    },
  },
  methods:{
    loadUserPermissions() {
      const employeeInfo = getEmployeeInfo()
      if (employeeInfo && employeeInfo.function) {
        try {
          this.userPermissions = JSON.parse(employeeInfo.function)
          console.log('✅ User permissions loaded:', this.userPermissions)
        } catch (e) {
          console.error('❌ Failed to parse user permissions:', e)
          this.userPermissions = []
        }
      } else {
        this.userPermissions = []
      }
    },
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-64 + 'px'}
    },
    // 解析日期，統一轉為本地時間，避免時差偏差 (同步 Dashboard.vue 寫法)
    parseDate(val1, val2, val3) {
      const target = val1 || val2 || val3
      if (!target || typeof target !== 'string') return null
      
      const dStr = target.substr(0, 10).replace(/\//g, '-')
      const parts = dStr.split('-')
      if (parts.length === 3) {
        return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]))
      }
      return null
    },
    redirectPath(path){
      this.$router.push(path).catch(err => {})
    },
    updateMenuHighlight(path) {
      if (!this.menus || this.menus.length === 0) return
      
      const normalizedPath = path.toLowerCase()
      
      // Exact Match
      let activeMenu = this.menus.find(m => m.path && normalizedPath === m.path.toLowerCase())
      
      // Pattern Match for sub-pages
      if (!activeMenu) {
        if (normalizedPath.includes('/jobassignment')) {
          activeMenu = this.menus.find(m => m.path === '/jobAssignmentList')
        } else if (normalizedPath.includes('/historyrecord')) {
          activeMenu = this.menus.find(m => m.path === '/historyRecordList')
        } else if (normalizedPath.includes('/warrantyandmaintenance') || normalizedPath.includes('/maintenance') || normalizedPath.includes('/device')) {
          activeMenu = this.menus.find(m => m.path === '/warrantyAndMaintenance')
        } else if (normalizedPath.includes('/configuration') || normalizedPath.includes('/organization') || normalizedPath.includes('/staff') || normalizedPath.includes('/customer')) {
          activeMenu = this.menus.find(m => m.path === '/Configuration')
        } else if (normalizedPath === '/' || normalizedPath === '') {
          activeMenu = this.menus.find(m => m.path === '/dashboard')
        }
      }
      
      if (activeMenu) {
        this.currentMenuName = activeMenu.name
        this.currentMenuIndex = this.menus.findIndex(m => m === activeMenu)
      }
    },

    initLanguage(){
      this.menus = [
        {
          name:i18n.t('__dashboard'),
          briefVal:'Basic',
          icon:'mdi-monitor-dashboard',
          path:'/dashboard',
        },
        {
          name:i18n.t('__jobAssignmentList'),
          briefVal:'Basic',
          icon:'mdi-home-account',
          permissionKey: 'JobAssignment',
          path:'/jobAssignmentList',
        },
        {
          name:i18n.t('__historyRecordList'),
          briefVal:'Basic',
          icon:'mdi-clipboard-text-clock-outline',
          permissionKey: 'HistoryRecord',
          path:'/historyRecordList',
        },
        {
          name:i18n.t('__warrantyAndMaintenance'),
          briefVal:'Basic',
          icon:'mdi-tools',
          permissionKey: 'WarrantyAndMaintenance',
          path:'/warrantyAndMaintenance',
        },
        {
          name:i18n.t('__Configuration'),
          briefVal:'Basic',
          icon:'mdi-cog',
          permissionKey: 'Configuration',
          path:'/Configuration',
        }
      ]
      this.updateMenuHighlight(this.$route.path)
    },
    setLanguage(language){
      switch(language){
        case 'tw':
        case 'en':
          i18n.locale = language
          // sessionStorage.setItem('locale', language)
          // this.$cookie.set('language', language, 30)
          break
        default:
          break
      }
    },
    enableMenu(menu){
      // If no permissionKey, show the menu (for backwards compatibility)
      if (!menu.permissionKey) {
        return true
      }
      
      // Check if user has view or edit permission for this menu
      const permission = this.userPermissions.find(p => p.key === menu.permissionKey)
      if (permission && (permission.view || permission.edit)) {
        return true
      }
      
      return false
    },
    canView(key) {
      const permission = this.userPermissions.find(p => p.key === key)
      return !!(permission && (permission.view || permission.edit))
    },
    enableSubMenu(submenu){
      var index = this.permission.findIndex(function(item){return item == submenu.twName})
      return (index != -1) ? true : true
    },
    getData(){
      // console.log("[getData] id: " + sessionStorage.getItem('manageMemberSysId'))
      var self = this
      let userData
      var request = {
        method: 'GET',
        url: '/GetJobAssignmentList',
        params: {},
      }
      this.$http(request).then(function(response) {
        userData = response.data.Data
        console.log(userData)
        // self.showBell = false
      }).catch(()=>{
        alert(this.$t('__systemError', { code: 'Hom-7976' }))
      }).finally(()=>{
        self.permission = (userData && userData.permission != null) ? userData.permission.split(',') : []
        // if(self.showBell){
        //   this.getNewEvent()
        // }
        // 修正刷新後強制導向 dashboard 的問題
        if (self.$route.path === '/') {
          self.redirectPath('/dashboard')
        }
      })
    },

    resetNotificationAndRedirectPath(messageId, path){
      var self = this
      var request = {
        method: 'POST',
        url: '/ReadEmployeeMessage',
        data: this.Qs.stringify({
          employeeId: 'superadmin',
          MessageID: messageId
        })
      }
      this.$http(request).then(function(response) {
        this.NOTICE_COUNT=0
        this.$router.push(path).catch(err => {})
      }).catch(()=>{
        this.NOTICE_COUNT=0
        this.$router.push(path).catch(err => {})
      })
    },
    updateExpansionPanel(menuIdx, submenuIdx){
      if(menuIdx!=null && submenuIdx!=null){
        this.expansionPanelValue = menuIdx
        this.currentMenuName = this.menus[menuIdx].name
        this.currentSubName = this.menus[menuIdx].item[submenuIdx].name
      }
    },
    selectMenu(menu){
      this.currentMenuName = menu.name
      if(menu.path){
        this.redirectPath(menu.path)
      }
      this.drawer = false // 點擊後關閉抽屜
    },
    selectSubMenu(submenu){
      this.currentSubName = submenu.name
      var index = this.permission.findIndex(function(item){return item == submenu.name})
      let bEditBank = (index != -1) ? 'true' : 'false'
      // sessionStorage.setItem('bEditBank', bEditBank)
      if(this.showBell){
        this.getNewEvent()
      }
      this.redirectPath(submenu.path)
    },
    clearMsgList(){
      this.msgList = []
    },
    async fetchNotificationCounts() {
      var self = this
      
      try {
        // 1. 取得天數設定 (X 和 Y)
        let maintenanceReminderDays = 30
        let deviceReminderDays = 30
        
        const settingsRes = await this.$http({
          method: 'GET',
          url: '/CodeTypeList',
          params: { CodeType: 'ExpiryReminder', currentPage: 1, pageSize: 9999 }
        })
        const settings = settingsRes.data?.Data || settingsRes.data?.data || []
        if (Array.isArray(settings)) {
          const mSet = settings.find(i => i.CodeText === 'Maintenance Contract')
          if (mSet) maintenanceReminderDays = parseInt(mSet.CodeValue) || 30
          const dSet = settings.find(i => i.CodeText === 'Device')
          if (dSet) deviceReminderDays = parseInt(dSet.CodeValue) || 30
        }

        const now = new Date()
        now.setHours(0, 0, 0, 0)

        // 2. Fetch Job Assignment count (保持先前寫好的 Email 比對邏輯)
        const jobRes = await this.$http({
          method: 'GET',
          url: '/GetJobAssignmentList',
          params: { pageSize: 9999, currentPage: 1 },
        })
        const rawJobs = jobRes.data?.Data || jobRes.data?.data || []
        const incompleteTasks = Array.isArray(rawJobs) ? rawJobs.filter(j => j.status !== 'Closed') : []
        const roles = getRoles()
        if (roles.isManager) {
          self.notificationCounts.jobAssignment = incompleteTasks.length
        } else {
          const employeeInfo = getEmployeeInfo()
          const myName = employeeInfo?.name || ''
          self.notificationCounts.jobAssignment = incompleteTasks.filter(j => j.assigned === myName).length
        }

        // 3. Fetch Maintenance Expiry count
        const maintRes = await this.$http({
          method: 'GET',
          url: '/GetMaintenanceList',
          params: { pageSize: 9999, currentPage: 1 },
        })
        const maintData = maintRes.data?.Data || maintRes.data?.data || []
        let mCount = 0
        if (Array.isArray(maintData)) {
          maintData.forEach(item => {
            const endDate = self.parseDate(item.endDate, item.endDateString)
            if (!endDate) return
            const diffDays = Math.round((endDate - now) / (1000 * 60 * 60 * 24))
            if (diffDays <= maintenanceReminderDays) mCount++
          })
        }
        self.notificationCounts.maintenanceExpiry = mCount

        // 4. Fetch Device Expiry count
        const deviceRes = await this.$http({
          method: 'GET',
          url: '/GetDeviceList',
          params: { pageSize: 9999, currentPage: 1 },
        })
        const deviceData = deviceRes.data?.Data || deviceRes.data?.data || []
        let dCount = 0
        if (Array.isArray(deviceData)) {
          deviceData.forEach(item => {
            // 條件：不在任何維護合約內 (依據 Dashboard/系統邏輯，通常維護中的設備 maintenanceId 不為空或 0)
            // 這裡判斷 item.maintenanceId 是否有效，若無維護合約才計算設備本身的保固到期
            // const inMaintenance = item.maintenanceId && item.maintenanceId !== '0' && item.maintenanceId !== 0
            // if (!inMaintenance) {
              const endDate = self.parseDate(item.endDate, item.endDateString, item.warrantyEndDate)
              if (!endDate) return
              const diffDays = Math.round((endDate - now) / (1000 * 60 * 60 * 24))
              if (diffDays <= deviceReminderDays) dCount++
            // }
          })
        }
        self.notificationCounts.deviceExpiry = dCount

      } catch (err) {
        console.error('Fetch notification counts failed:', err)
      }
    },
    logout(){
      // remove sessionStorage
      sessionStorage.removeItem('manageMemberToken')
      sessionStorage.removeItem('manageMemberName')
      sessionStorage.removeItem('manageMemberSysId')
      this.redirectPath('/login')
    }
  }
}
</script>

<style>
  .sidebar-expanded {
    width: 200px !important;
    min-width: 200px !important;
  }
  .sidebar-collapsed {
    width: 64px !important;
    min-width: 64px !important;
  }
  .menu-item-row {
    min-height: 60px !important;
    height: auto !important;
    margin: 4px 8px !important;
    border-radius: 8px !important;
    display: flex;
    align-items: center;
  }
  .multiline-title {
    white-space: normal !important;
    line-height: 1.2 !important;
    word-break: break-word;
    font-size: 0.9rem !important;
  }
  .menu-item-row:hover {
    background-color: rgba(237, 109, 0, 0.08) !important;
  }
  .menu-item-row .v-list-item__icon {
    margin-top: auto !important;
    margin-bottom: auto !important;
    align-self: center !important;
  }
  .header-icon-btn {
    margin-left: 2px !important;
  }
  .header-icon-btn .v-badge__badge {
    left: auto !important;
    right: -1px !important;
    bottom: 1px !important;
  }
  .headerName {
    font-size: 14px;
    letter-spacing: 0.5px;
  }
  .notification-center-card {
    overflow: hidden;
  }
  .notification-col {
    cursor: pointer;
    transition: background-color 0.2s;
    border-radius: 4px;
    padding: 8px 0 !important;
  }
  /* 相鄰項目之間自動加分隔線，選單點長奈不需手動處理 */
  .notification-col + .notification-col {
    border-left: 1px solid #e0e0e0;
  }
  .notification-col:hover {
    background-color: rgba(237, 109, 0, 0.05);
  }
</style>
